module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMCAyMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtvcGFjaXR5OjAuOTt9LmNscy0ye2ZpbGw6bm9uZTtzdHJva2U6I2U2ZTZlNTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IuWbvuWxgl84IiBkYXRhLW5hbWU9IuWbvuWxgiA4Ij48ZyBjbGFzcz0iY2xzLTEiPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjMuNTciIHkxPSI0LjIxIiB4Mj0iMTYuNDMiIHkyPSIxNy4wNiIvPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjE2LjQzIiB5MT0iNC4yMSIgeDI9IjMuNTciIHkyPSIxNy4wNiIvPjwvZz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/cancelWhite.svg
// module id = Phio
// module chunks = 0